class GlossaryFilters extends HTMLElement {
  connectedCallback () {
    this.grid = document.querySelector('.sec-Glossary_Grid')
    this.filterButtons = this.querySelectorAll('.sec-Glossary_FilterListItem')
    this.filterItems = this.querySelectorAll('.sec-Glossary_GridItem')

    if (this.filterButtons.length > 0 && this.filterItems.length > 0) {
      this.init()
    }
  }

  init () {
    this.filterButtons.forEach(button => {
      button.addEventListener('click', (event) => this.filterGrid(event))
    })
  }

  filterGrid (event) {
    event.preventDefault()

    const target = event.target.closest('[data-filter-tag]')
    if (!target) return

    const selectedTag = target.dataset.filterTag

    if (!selectedTag) {
      return
    }

    this.filterButtons.forEach((btn) => {
      btn.classList.remove('is-Active')
    })
    target.classList.add('is-Active')

    this.filterItems.forEach((item) => {
      const itemTag = item.dataset.tag

      if (itemTag === selectedTag || selectedTag === 'all') {
        item.classList.remove('sec-Glossary_GridItem-hidden')
      } else {
        item.classList.add('sec-Glossary_GridItem-hidden')
      }
    })
  }
}

if (!customElements.get('glossary-filters')) {
  customElements.define('glossary-filters', GlossaryFilters)
}
